import * as v from 'valibot';

export const Stats = v.object({
	openRisksNo: v.number(),
	closedRisksNo: v.number(),
	riskInProgressNo: v.number(),
	pendingUnderwriterNo: v.number(),
	calculationCompletedNo: v.number(),
});

export type Stats = v.InferOutput<typeof Stats>;
